import { Component, Inject, OnInit } from '@angular/core';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { FormBuilder, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { HtmlEditorService, LinkService, ImageService as SynImageService, ToolbarService } from '@syncfusion/ej2-angular-richtexteditor';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Lightbox } from 'ngx-lightbox';
import { environment } from '../../../../../../../../environments/environment';
import { fuseAnimations } from '../../../../../../../core/animations';
import { MY_FORMATS } from '../../../../../../const/date-format';
import { NoticiaMultimedia } from '../../../../../../models/multimedia-noticia/noticia-multimedia';
import { Noticia } from '../../../../../../models/noticias/noticia';
import { AuthenticationService } from '../../../../../../services/authentication/authentication.service';
import { ImageService } from '../../../../../../services/images/image.service';
import { NoticiasService } from '../../../../../../services/noticias/noticias.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { TipoNoticiasService } from '../../../../../../services/tipo-noticias/tipo-noticia.service';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { NoticiaDialogData } from './subject-noticia-data';
import { TipoNoticia } from '../../../../../../models/tipo-noticias/tipo-noticia';



@Component({
    selector: 'fuse-add-menu',
    templateUrl: './add-menu.component.html',
    styleUrls: ['./add-menu.component.scss'],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
        ToolbarService, LinkService, SynImageService, HtmlEditorService
    ],
    
    animations: fuseAnimations
})
export class AddMenuComponent implements OnInit, AfterViewInit {

    @BlockUI('tracker-dialog') blockUI: NgBlockUI;

    subjectFormGroup;

    subjectNameControl;
    subjectDescriptionControl;

    tipoNoticiaFormControl;

    public baseUri;
    multimedias: any[]= [];

    public tools: object = {
        items: ['Undo', 'Redo', '|',
            'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
            'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
            'SubScript', 'SuperScript', '|',
            'LowerCase', 'UpperCase', '|',
            'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
            'Indent', 'Outdent', '|', 'CreateLink','CreateTable',
            'Image', '|', 'ClearFormat']
    };
    public quickTools: object = {
        image: [
            'Replace', 'Align', 'Caption', 'Remove', 'InsertLink', '-', 'Display', 'AltText', 'Dimension']
    };

    public insertImageSettings: object = {
        saveFormat: 'Base64'
    }
    tipoNoticias = [];
    desactivados: string[]= [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: NoticiaDialogData,
        public dialogRef: MatDialogRef<AddMenuComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private fb: FormBuilder,
        private authenticationService: AuthenticationService,
        private _lightbox: Lightbox,
        private noticiasService: NoticiasService,
        private tipoNoticiasService: TipoNoticiasService,
        private imageService: ImageService,
    ) {
        console.log('data', data);
        this.initializeFormControlValidators();
        this.baseUri = environment.baseUri + '/images/';
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);

        console.log(this.data.noticia);
        if (this.data.mode === 'view') {
            this.disable();
        }

        this.tipoNoticiasService.getAll().subscribe(e => {
            this.tipoNoticias = [...e];
            this.blockUI.stop();
        });
    
        
    }

    disable() {
        this.subjectFormGroup.get('subjectNameControl').disable();
        this.subjectFormGroup.get('subjectDescriptionControl').disable();
        this.subjectFormGroup.get('tipoNoticiaFormControl').disable();
    }

    ngAfterViewInit() {

    }

    initializeFormControlValidators() {
        this.subjectFormGroup = this.fb.group({
            subjectNameControl: ['', [Validators.required]],
            subjectDescriptionControl: ['', []],
            tipoNoticiaFormControl: ['', []]
        });
    }


    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    save() {
        this.blockUI.start(this.translationService.savingChanges);
        console.log(this.desactivados);
        let orderCounter = 1; 
        this.tipoNoticias.forEach(item => {
            item.Orden = orderCounter++; 
            item.Hijos.forEach(hijo => {
                hijo.Orden = orderCounter++;
            });
        });

        this.tipoNoticiasService.add(this.tipoNoticias, this.desactivados ).subscribe(e => {
            this.blockUI.stop();
            this.translationService.translate('LABELS.CORRECTLY_MODIFIED', this.translationService.menu, (res) => {
                this.sweetAlertService.success(this.translationService.success, res, null);
            });
            this.dialogRef.close();
        });
    }

    addMenuPadre() {
        this.tipoNoticias.push(new TipoNoticia());
    }

    addMenuHijo(c: any) {
        c.Hijos.push(new TipoNoticia());
    }
    
    moverPadreArriba(index:any) {
        console.log(index);
        if (index > 0) {
            const temp = this.tipoNoticias[index];
            this.tipoNoticias[index] = this.tipoNoticias[index - 1];
            this.tipoNoticias[index - 1] = temp;
        }
    }

    moverPadreAbajo(index: number): void {
        if (index < this.tipoNoticias.length - 1) {
          const temp = this.tipoNoticias[index];
          this.tipoNoticias[index] = this.tipoNoticias[index + 1];
          this.tipoNoticias[index + 1] = temp;
        }
    }

    moverHijoArriba(index:any, h: any) {
        console.log(index);
        if (index > 0) {
            const temp = h.Hijos[index];
            h.Hijos[index] = h.Hijos[index - 1];
            h.Hijos[index - 1] = temp;
        }
    }

    moverHijoAbajo(index: number, h: any): void {
        if (index < h.Hijos.length - 1) {
          const temp = h.Hijos[index];
          h.Hijos[index] = h.Hijos[index + 1];
          h.Hijos[index + 1] = temp;
        }
    }

    removeItemPadre(index: number): void {
        this.desactivados.push(this.tipoNoticias[index].Id)
        this.tipoNoticias[index].Hijos.forEach(element => {
            this.desactivados.push(element.Id)
        });
        this.tipoNoticias.splice(index, 1); // Elimina el ítem en el índice especificado
    }

    removeItemHijo(index: number, h:any): void {
        console.log(index);
        this.desactivados.push(h.Hijos[index].Id)
        h.Hijos.splice(index, 1); // Elimina el ítem en el índice especificado
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/noticias/components/add-menu/add-menu.component.ts